import { lazy } from "react";
import { SuspenseWrapper } from "@/shared/components/feedback/SuspenseWrapper";

const AdminDashboardPage = lazy(() => import("@/pages/admin/AdminDashboardPage"));
const AdminTenantsPage = lazy(() => import("@/pages/admin/AdminTenantsPage"));
const AdminTenantDetailPage = lazy(() => import("@/pages/admin/AdminTenantDetailPage"));
const AdminPlansPage = lazy(() => import("@/pages/admin/AdminPlansPage"));
const AdminUsersPage = lazy(() => import("@/pages/admin/AdminUsersPage"));
const AdminBillingPage = lazy(() => import("@/pages/admin/AdminBillingPage"));
const AdminSystemSettingsPage = lazy(() => import("@/pages/admin/AdminSystemSettingsPage"));

interface RouteConfig {
  path: string;
  element: React.ReactElement;
}

const withSuspense = (Component: React.LazyExoticComponent<React.ComponentType<unknown>>) => (
  <SuspenseWrapper>
    <Component />
  </SuspenseWrapper>
);

export const adminRoutes: RouteConfig[] = [
  { path: "/admin",                 element: withSuspense(AdminDashboardPage) },
  { path: "/admin/dashboard",       element: withSuspense(AdminDashboardPage) },
  { path: "/admin/tenants/:id",     element: withSuspense(AdminTenantDetailPage) },
  { path: "/admin/tenants",         element: withSuspense(AdminTenantsPage) },
  { path: "/admin/plans",           element: withSuspense(AdminPlansPage) },
  { path: "/admin/users",           element: withSuspense(AdminUsersPage) },
  { path: "/admin/billing",         element: withSuspense(AdminBillingPage) },
  { path: "/admin/system-settings", element: withSuspense(AdminSystemSettingsPage) },
];
